import React, { ChangeEvent, FC, useState } from 'react';
import Modal from '../../../components/Modal/Modal';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import { useMenuDump } from '../hooks/useMenuDump';
import { Variant } from '../../../components/Button/Button.types';
import { RadioGroupLayouts } from '../../../components/RadioGroup/RadioGroup.types';
import { StyledButtons, StyledMessage } from '../../Recipes/Recipes.styles';

interface MenuDumpModalProps {
  open: boolean;
  onClose: () => void;
}

export enum MenuStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

const MenuDumpModal: FC<MenuDumpModalProps> = (
    {
      open,
      onClose
    }
) => {
  const [franchiseCode, setFranchiseCode] = useState('');
  const [menuStatus, setMenuStatus] = useState<MenuStatus>(MenuStatus.INACTIVE);

  const { mutate: handleGenerateReport, data: downloadUrl, isLoading: isGenerating, isError, error } = useMenuDump();

  const handleClose = () => {
    onClose();
    setFranchiseCode('');
    setMenuStatus(MenuStatus.INACTIVE);
  };

  const updateFranchiseCode = (
      inputChangeEvent: ChangeEvent<HTMLInputElement>
  ) => {
    setFranchiseCode(inputChangeEvent.target.value.toUpperCase());
  };

  const generateReport = () => {
    handleGenerateReport({franchiseCode, menuStatus});
  };

  return (
    <Modal id="menu-dump-modal" open={open} onClose={handleClose} title="Menu Dump">
      <div>
        <StyledMessage>
          Enter a 3-letter franchise code to generate a menu dump.
        </StyledMessage>
        <div style={{ display: 'flex', alignItems: 'flex-end', marginTop: '1rem' }}>
          <Input
            id="franchise-code"
            label="Franchise Code"
            value={franchiseCode}
            onChange={updateFranchiseCode}
            maxLength={3}
            style={{ marginRight: '1rem' }}
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <RadioGroup
            id="menu-status"
            label="Menu Status"
            layout={RadioGroupLayouts.Row}
            selected={menuStatus}
            onChange={(inputChangeEvent: React.ChangeEvent<HTMLInputElement>) => {
              //TODO: Fix Radio Group to properly use values
              setMenuStatus(inputChangeEvent.target.id as MenuStatus)
            }}
            options={[
              { id: MenuStatus.INACTIVE, label: 'Inactive Menus' },
              { id: MenuStatus.ACTIVE, label: 'Active Menus' }
            ]}
          />
        </div>
        <StyledButtons>
          <Button
            variant={Variant.Secondary}
            label="Cancel"
            onClick={handleClose}
            style={{ marginRight: '1rem' }}
          />
          <Button
            variant={Variant.Primary}
            label="Generate"
            onClick={generateReport}
            disabled={isGenerating || franchiseCode.length !== 3}
            isLoading={isGenerating}
          />
        </StyledButtons>
        {downloadUrl && (
          <div style={{ marginTop: '1rem' }}>
            <p>
              Report is ready!{' '}
              <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
                Download here
              </a>
            </p>
          </div>
        )}
        {isError && (
          <div style={{ marginTop: '1rem', color: 'red' }}>
            <p>{error.message}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MenuDumpModal;